// extracted by mini-css-extract-plugin
module.exports = {"button":"PrevArrowButton_button__2YDj9"};